import React, { FC } from "react";

import Product from "../../components/Product";

const ProductListPage: FC = () => <Product/>;

export default ProductListPage;
